import { render, staticRenderFns } from "./CourseCertificates.vue?vue&type=template&id=51fa2ff8&"
import script from "./CourseCertificates.vue?vue&type=script&lang=js&"
export * from "./CourseCertificates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports